import { useCallback, useState } from 'react';
import { DateRangePicker, RangeKeyDict } from 'react-date-range';
import { DateRangeState } from 'utils';

import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';

import './dateRange.css';

type DateRangePickerProps = {
  onChange: ({ startDate, endDate }: DateRangeState) => void;
  months?: number;
};

const DateRange = ({
  onChange,
  months = 2,
}: DateRangePickerProps) => {
  const [savedSelectedDate, setSavedSelectedDate] = useState<DateRangeState>({
    startDate: new Date(), endDate: new Date()
  });

  const handleSelect = useCallback(
    ({ selection }: RangeKeyDict) => {
      if (selection.startDate && selection.endDate) {
        setSavedSelectedDate({ startDate: selection.startDate, endDate: selection.endDate });
        onChange({ startDate: selection.startDate, endDate: selection.endDate });
      }
    },
    [onChange]
  );

  return (
  <DateRangePicker
    onChange={handleSelect}
    preview={{}}
    inputRanges={[]}
    weekStartsOn={1}
    showDateDisplay={false}
    showPreview={false}
    moveRangeOnFirstSelection
    months={months}
    ranges={[
      {
        startDate: savedSelectedDate.startDate,
        endDate: savedSelectedDate.endDate,
        key: 'selection'
      }
    ]}
    direction="horizontal"
  />
  );
};

export { DateRange };